import { Injectable } from '@angular/core'
import { FilterGroup } from '@helios/common-api'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { DeleteFilterGroupConfirmationModalComponent } from './delete-filter-group-confirmation-modal.component'

@Injectable()
export class DeleteFilterGroupConfirmationModalService {
  constructor(private readonly modalService: NgbModal) {}

  toggle(group: FilterGroup): Promise<void> {
    const modalRef = this.modalService.open(
      DeleteFilterGroupConfirmationModalComponent,
      { size: 'sm', keyboard: false },
    )
    const component =
      modalRef.componentInstance as DeleteFilterGroupConfirmationModalComponent
    component.filterGroupToBeDeleted = group
    return modalRef.result
  }
}
